import axios from "axios";

export const state = {
    documenttypes: [],
    loadingDocumentTypes: false,
};

export const getters = {
    documenttypes: state => state.documenttypes,
    loadingDocumentTypes: state => state.loadingDocumentTypes,
};

export const mutations = {
    setDocumentTypes(state, newValue) {
        state.documenttypes = newValue || []
    },
    setLoadingDocumentTypes(state, newValue) {
        state.loadingDocumentTypes = newValue
    },
};

export const actions = {
    async fetchDocumentTypes({ commit }) {
        commit('setLoadingDocumentTypes', true);
        try {
            const res = await axios.get('/document-types');
            commit('setDocumentTypes', res.data.document_types || []);
        } catch (error) {
            alert(error);
        } finally {
            commit('setLoadingDocumentTypes', false);
        }
    },
};
